import React from 'react';

// Icône Batterie avec niveau dynamique
const BatteryIcon = ({ sx, level = 100 }) => {
  // Calculer la couleur selon le niveau
  const getColor = () => {
    if (level > 60) return '#4caf50'; // Vert
    if (level > 20) return '#ff9800'; // Orange
    return '#f44336'; // Rouge
  };

  const fillHeight = (level / 100) * 14; // Hauteur max 14px

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={sx}
    >
      {/* Contour batterie */}
      <rect x="7" y="6" width="10" height="16" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" />
      
      {/* Borne positive */}
      <rect x="10" y="3" width="4" height="3" rx="1" fill="currentColor" />
      
      {/* Niveau de charge */}
      <rect 
        x="8" 
        y={21 - fillHeight} 
        width="8" 
        height={fillHeight} 
        fill={getColor()} 
      />
      
      {/* Pourcentage */}
      <text
        x="50%"
        y="60%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="6"
        fill="white"
        fontWeight="bold"
      >
        {level}%
      </text>
    </svg>
  );
};

export default BatteryIcon;
